import React from "react";
import { ChevronRight } from "lucide-react";
import {
  HeroCarousel,
  HeroCard,
  HeroCopy,
  HeroCta,
  HeroDots,
  HeroEyebrow,
  HeroSlide,
  HeroTrack,
  HeroTitle,
  HeroViewport,
} from "./styles.banner";

export default function Banner({
  bannerSlides,
  heroEmblaRef,
  selectedBannerIndex,
  bannerProgress,
  handleBannerDotClick,
  handleBannerClick,
}) {
  return (
    <HeroCarousel>
      <HeroViewport ref={heroEmblaRef}>
        <HeroTrack>
          {bannerSlides.map((banner, index) => (
            <HeroSlide key={`${banner.id || "banner"}-${index}`}>
              <HeroCard
                onClick={() => handleBannerClick(banner)}
                disabled={!banner.action_type}
                $backgroundImage={banner.image_url}
              />
            </HeroSlide>
          ))}
        </HeroTrack>
      </HeroViewport>
      {bannerSlides.length > 1 ? (
        <HeroDots aria-hidden="true">
          {bannerSlides.map((banner, index) => (
            <button
              key={banner.id || index}
              type="button"
              data-active={index === selectedBannerIndex % bannerSlides.length}
              onClick={() => handleBannerDotClick(index)}
            >
              <span
                style={{
                  transform: `scaleX(${index === selectedBannerIndex % bannerSlides.length ? bannerProgress : 0})`,
                }}
              />
            </button>
          ))}
        </HeroDots>
      ) : null}
    </HeroCarousel>
  );
}
